import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
export default function Footer(_a) {
    var left = _a.left, right = _a.right, rightColor = _a.rightColor;
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, null),
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", mt: 0 },
            left && React.createElement(Typography, { fontSize: "small", color: "darkgrey.main" }, left),
            right && React.createElement(Typography, { fontSize: "small", color: rightColor !== null && rightColor !== void 0 ? rightColor : 'darkgrey.main' }, right))));
}
//# sourceMappingURL=DataStructureSyncSelectionDialogFooter.js.map